export default function sysLangToTranslationLang(
  lang: General.Language,
): General.TranslationLanguageKey {
  return lang.replace('-', '') as unknown as General.TranslationLanguageKey;
}
